import React from "react";
import Button from "@rio-cloud/rio-uikit/Button";
import Dialog from "@rio-cloud/rio-uikit/Dialog";
import { useIntl } from "react-intl";

export type ExportStage =
  | "maintenance"
  | "complementary"
  | "checkups"
  | "rioplans"
  | "writing"
  | "done"
  | "error";

interface IExportProgressDialogProps {
  show: boolean;
  stage: ExportStage;
  progress: number; // 0..100
  detail?: string;
  errorMessage?: string;
  onClose: () => void;
}

const STAGE_LABEL_ID: Record<ExportStage, string> = {
  maintenance: "intl-msg:common.exportProgressDialog.stage.maintenance",
  complementary: "intl-msg:common.exportProgressDialog.stage.complementary",
  checkups: "intl-msg:common.exportProgressDialog.stage.checkups",
  rioplans: "intl-msg:common.exportProgressDialog.stage.rioplans",
  writing: "intl-msg:common.exportProgressDialog.stage.writing",
  done: "intl-msg:common.exportProgressDialog.stage.done",
  error: "intl-msg:common.exportProgressDialog.stage.error",
};

const ExportProgressDialog = ({
  show,
  stage,
  progress,
  detail,
  errorMessage,
  onClose,
}: IExportProgressDialogProps) => {
  const intl = useIntl();
  return (
    <Dialog
      show={show}
      bsSize="md"
      title={intl.formatMessage({ id: "intl-msg:common.exportProgressDialog.title" })}
      subtitle={intl.formatMessage({ id: "intl-msg:common.exportProgressDialog.subtitle" })}
      footer={
        <Button onClick={onClose} className="btn btn-primary" bsSize="lg">
          {intl.formatMessage({ id: "intl-msg:common.exportProgressDialog.close" })}
        </Button>
      }
      body={
        <div className="w-full mx-auto bg-white rounded-lg p-6">
          {/* Texto da etapa atual */}
          <div className="text-size-16 text-color-darkest mb-3">
            {intl.formatMessage({ id: STAGE_LABEL_ID[stage] })}
            {detail ? ` — ${detail}` : ""}
          </div>

          {/* Barra de progresso */}
          <div className="h-[10px] w-full rounded progress overflow-hidden mb-2">
            <div
              className="h-full progress-bar progress-bar-striped progress-bar-primary transition-all duration-200"
              style={{ width: `${Math.max(0, Math.min(100, progress))}%` }}
            />
          </div>

          {/* Percentual */}
          <div className="text-right text-size-16 text-color-darkest mb-2">
            {Math.round(progress)}%
          </div>

          {/* Mensagem de erro */}
          {stage === "error" && (
            <div className="text-color-danger text-size-14">
              {errorMessage || intl.formatMessage({ id: "intl-msg:common.exportProgressDialog.genericError" })}
            </div>
          )}
        </div>
      }
      onCloseValidation={() => {
        onClose();
        return true;
      }}
      showCloseButton
    />
  );
};

export default ExportProgressDialog;
